import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './onlinechallenge.css';

import heroOnline1 from '../src/images/hero-online-1.png';
//import heroOnline2 from '../src/images/hero-online-2.png';

import challengePic from '../src/images/challenge-pic.png';

import WinPrizes from './components/WinPrizes';
import Header from './components/Header';
import ChallengeVideo from './components/ChallengeVideo';


function OnLineChallenge() {
  return (
    <div>
      <Helmet>
        <title>On-line Challenge | Gulf Oil India</title>
        <meta name="description" content="Pick-Up Your Dream and take the on-line challenge now. Don't wait. Participate now to win exciting prizes!" />
      </Helmet>
      <section className="generic-padding hero-online-wrapper">
        <Container>
          <Header />
          <Row>
            <Col lg={6} className="pt-lg-5">
              <img src={heroOnline1} className="img-fluid" alt="Gulf Oil India" />
            </Col>
          </Row>
        </Container>
        <span className="hero-img hero-img-online"></span>
        <div className="hero-online-mask"></div>
      </section>
      <section className="generic-padding home-mid-wrapper">
        <Container>
          <h2 className="sub-title sub-title-orange text-center">TAKE THE ON-LINE CHALLENGE</h2>
          <ChallengeVideo />          
          <Row className="mb-4 mt-5 align-items-center no-gutters">
            <Col md={6} className="font-italic">
              <h3 className="text-uppercase font-weight-bold">Pick-Up Your Dream and <br className="d-none d-lg-block" />
                <span className="text-orange">take the on-line challenge NOW!</span></h3>
              <div className="font-size-6">
                <p className="text-orange">ALL YOU HAVE TO DO :</p>
                <p>STEP 1: Upload a video of yourself taking any one of the
               above challenges with a Gulf Pride Engine Oil can
               featuring in your video</p>
                <p>STEP 2: Use <span className="text-orange">#PICKUPYOURDREAM2</span> along with your video
               on FACEBOOK or INSTAGRAM</p>
              </div>
            </Col>
            <Col md={6} className="text-center">
              <img src={challengePic} className="img-fluid" alt="" />
            </Col>
          </Row>
          <WinPrizes />
          <div className="text-center mt-5">
            <div className="participate-now">don’t wait, participate now!</div>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default OnLineChallenge;